// src/pages/RadiantIsleRH.js
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function BerryShop() {
  React.useEffect(() => {
    document.title = "Berry Shop | Pokémon Radiance";
  }, []);

  return <GameMap config={mapConfigs.berryShop} />;
}
